import { z } from 'zod';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';

export const CalibrationLevel = z
  .enum([
    'poor',
    'belowAverage',
    'average',
    'good',
    'veryGood',
    'excellent',
    'best',
  ])
  .describe('CalibrationLevel');

export type CalibrationLevel = z.infer<typeof CalibrationLevel>;

export const CalibrationLevels = Object.values(CalibrationLevel.Values);

export const getCalibrationLevel = (
  calibrationScore: number,
): CalibrationLevel => {
  if (calibrationScore >= 6) {
    return 'best';
  }

  if (calibrationScore >= 5) {
    return 'excellent';
  }

  if (calibrationScore >= 4) {
    return 'veryGood';
  }

  if (calibrationScore >= 3) {
    return 'good';
  }

  if (calibrationScore >= 2) {
    return 'average';
  }

  if (calibrationScore >= 1) {
    return 'belowAverage';
  }

  return 'poor';
};

export const predictCalibrationScore = ({
  calibrationScore,
  impactFactor,
}: {
  calibrationScore: number;
  impactFactor: number;
}): number => {
  if (impactFactor === 0) {
    return calibrationScore;
  }

  const scale = 0.15 * (Math.pow(1.2, 6 - calibrationScore) - 0.5);
  const predictedBiasScore = Math.min(
    calibrationScore + scale * impactFactor,
    6,
  );
  return Math.max(predictedBiasScore, calibrationScore);
};
